import formatterNumber from "./formatterNumber"
import getInstrumentPrice from "./getInstrumentPrice"
import roundToTwo from "./roundToTwo"

export default async function getContractValueUSD(
  data: InstrumentData | undefined,
  selectedOperation: string,
  contractSize: string | undefined,
  usdValue?: string
) {
  if (!data) return 0

  // Normalización de datos de entrada
  const instrumentPrice = parseFloat(getInstrumentPrice(data, selectedOperation))
  const size = parseFloat(contractSize?.replace(/,/g, "") || "0")
  const usdFx = usdValue ? parseFloat(usdValue) : undefined

  let contractValueUSD = 0

  // 🔹 CASO 1: Base currency es USD → valor nocional directo
  if (data.base_currency === "USD") {
    contractValueUSD = size * instrumentPrice
  }

  // 🔹 CASO 2: Margin currency es USD → valor nocional directo (ya expresado en USD)
  else if (data.margin_currency === "USD") {
    contractValueUSD = size
  }

  // 🔹 CASO 3: Margin currency es EUR → convertir de CLP/JPY/USD a EUR
  else if (data.margin_currency === "EUR") {
    if (usdFx && data.base_currency === "EUR") {
      // Ejemplo: DE.HLAG (base EUR, margin EUR, usdValue = EURUSD)
      // Convertir EUR → USD → EUR => multiplicamos por EURUSD si queremos el valor en USD
      contractValueUSD = size * instrumentPrice * usdFx
    } else if (usdFx && data.base_currency !== "USD") {
      // Determinar si usdValue es EURUSD o USDxxx
      // Si nemo empieza con EUR y base_currency es moneda escandinava/exótica, usdValue es USDxxx
      const isEurPair = data.nemo?.startsWith("EUR")
      const isCommonEurQuote = ["GBP", "CHF", "AUD", "NZD", "CAD"].includes(data.base_currency)

      if (isEurPair && !isCommonEurQuote) {
        // Ejemplo: EURNOK (usdValue=USDNOK) → EURUSD = EURNOK / USDNOK
        contractValueUSD = (size * instrumentPrice) / usdFx
      } else {
        // Ejemplo: EURGBP (usdValue=EURUSD) → multiplicar por EURUSD
        contractValueUSD = size * instrumentPrice * usdFx
      }
    } else if (data.base_currency === "USD") {
      // Ejemplo: USDCLP → ya está en USD
      contractValueUSD = size * instrumentPrice
    } else {
      // Sin usdValue o sin caso específico → fallback directo
      contractValueUSD = size * instrumentPrice
    }
  }

  // 🔹 CASO 4: Cruce exótico (ni base ni margin currency son USD o EUR)
  else {
    if (usdFx) {
      // Ejemplo: GBPCLP o NZDJPY
      contractValueUSD = (size * instrumentPrice) / usdFx
    } else {
      contractValueUSD = size * instrumentPrice
    }
  }

  // 🔹 Formateo final
  if (isNaN(contractValueUSD)) return 0

  const rounded = roundToTwo(contractValueUSD)

  if (rounded !== parseInt(String(rounded))) {
    return formatterNumber(2).format(rounded)
  } else {
    return formatterNumber().format(rounded)
  }
}
